(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialized = new WeakSet();
  const animate = (scope = document) => {
    if (reduced.matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('wf-visible');
        observer.unobserve(entry.target);
      }
    }, { threshold: 0.08, rootMargin: '0px 0px 30px 0px' });
    scope.querySelectorAll('[data-atelier-reveal]').forEach((element) => {
      if (initialized.has(element)) return;
      initialized.add(element);
      if (element.getBoundingClientRect().top < innerHeight) return;
      element.classList.add('wf-pending');
      observer.observe(element);
    });
  };
  const openers = new WeakMap();
  let previousOverflow = '';
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const opener = event.target.closest('[data-atelier-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.atelierOpen);
      if (!(dialog instanceof HTMLDialogElement)) return;
      openers.set(dialog, opener);
      previousOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
    }
    const closer = event.target.closest('[data-atelier-close]');
    if (closer) closer.closest('dialog')?.close();
    if (event.target.matches('dialog.wf-lightbox') && event.target.open) event.target.close();
  });
  document.addEventListener('close', (event) => {
    if (!(event.target instanceof HTMLDialogElement) || !event.target.matches('.wf-lightbox')) return;
    document.documentElement.style.overflow = previousOverflow;
    openers.get(event.target)?.focus({preventScroll: true});
  }, true);
  reduced.addEventListener('change', () => {
    if (reduced.matches) document.querySelectorAll('.wf-pending').forEach((element) => element.classList.add('wf-visible'));
  });
  document.addEventListener('shopify:section:load', (event) => animate(event.target));
  animate();
})();
